export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11291.a486925a.jpg";